<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import type { RadioGroupRootEmits, RadioGroupRootProps } from 'reka-ui'
import { reactiveOmit } from '@vueuse/core'
import { RadioGroupRoot, useForwardPropsEmits } from 'reka-ui'
import { cn } from '@ds/lib/utils'

/*
 * Reka's RadioGroup: one tab stop for the whole group, arrow keys between
 * options, `aria-checked` per item. Stacked by default; a row of choice cards
 * passes its own layout.
 */
const props = defineProps<RadioGroupRootProps & { class?: HTMLAttributes['class'] }>()
const emits = defineEmits<RadioGroupRootEmits>()

const delegatedProps = reactiveOmit(props, 'class')

const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <RadioGroupRoot
    v-bind="forwarded"
    :class="cn('grid gap-2 font-ds', props.class)"
  >
    <slot />
  </RadioGroupRoot>
</template>
